import React, {Component} from 'react';
import {BaseEventEditor, BaseEventViewer} from './base_event';
import {RelatedToOptions} from '../../../constants.js.erb';

class MedPathologyReportEditor extends BaseEventEditor {
  formFields() {
    let {patient} = this.props;
    return formFields(patient);
  }
}


class MedPathologyReportViewer extends BaseEventViewer {
  formFields() {
    let {patient} = this.props;
    return formFields(patient);
  }
}


export default {
  viewer: MedPathologyReportViewer,
  editor: MedPathologyReportEditor
}


function formFields(patient) {
  let contacts = patient.contacts.map(c => {return {id: c.id, text: c.name}});
  let medical_team_members = patient.medical_team_members.map(m => {return {id: m.id, text: m.person.name}});
  let medical_centers = patient.medical_centers.map(mc => { return {id: mc.id, text: mc.cancer_center.name}});

  return [
    {name: 'date', type: 'date', required: true, label: 'Date Pathology Report was Received by Sagely Health', inSummary: true},
    {name: 'date_estimated', label: 'Date Estimated?', type: 'bool'},
    {name: 'related_to', type: 'select', collection: RelatedToOptions},
    {name: 'medical_record_date', type: 'date', required: true, inSummary: true},
    {name: 'medical_center_id', label: 'Cancer Center', type: 'select2', collection: medical_centers, idField: 'id', labelField: 'text', hint: 'To appear here, the medical center must be added to the patient.'},
    {name: 'tumor_type'},
    {name: 'size'},
    {name: 'pathologist_notes', label: 'Pathologist\'s Notes', type: 'text', inSummary: true},
    {name: 'user', label: 'To whom or how was this pathology report sent to Sagely Health?'},
    {name: 'peer_type', type: 'select', collection: ['patient', 'contact', 'medical_team', 'other'], labelTransform: 'titleize', label: 'Sent by'},
    {name: 'contact_id', type: 'select2', collection: contacts, visible: e => e.peer_type === 'contact', idField: 'id', labelField: 'text', hint: 'To appear here, contacts must be added to the patient.'},
    {name: 'medical_team_member_id', type: 'select2', collection: medical_team_members, visible: e => e.peer_type === 'medical_team', idField: 'id', labelField: 'text', hint: 'To appear here, medical team members must be added to the patient.'},
    {name: 'description', type: 'text', inSummary: true}
  ];
}
